module.exports = __webpack_public_path__ + "static/media/loop.142e063b.m4a";